export const volumesAccordionSlideAnimationDurationMs = 375;